import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import { get_token } from "@/router";
import Swal from 'sweetalert2';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

export default {
  components: {
    Sidebar,
    Navbar,
    InactivityModal
  },
  data() {
    return ({
      isLoading: false,
      businesses: [],
    });
  },

  methods: {

    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
     initDataTable(id) {
      const table = $(id)

      if (!table.length) return

      // Destroy if already initialised
      if ($.fn.DataTable.isDataTable(id)) {
        table.DataTable().clear().destroy()
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next"
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available"
        }
      })
    },
    fetch_businesses() {
      this.isLoading = true;
      return new Promise(() => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_company_profile/`,
          method: 'GET',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          success: (data) => {
            this.businesses = data.data || [];
            this.$nextTick(() => {
              this.initDataTable('#businessTable')
            });
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      });
    },
  
    view_profile(profile){
        const base = profile.base_profile.id;
        const type = profile.base_profile.profile_type;
        window.location.href = `/profile?base=${base}&type=${type}`;
      },
      delete_company_profile(profile_id) {
        Swal.fire({
          title: 'Are you sure?',
          text: 'This will permanently delete the company profile.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!',
          position: 'bottom-end',
          toast: true
        }).then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_company_profile/${profile_id}/`,
              type: 'DELETE',
              headers: {
                Authorization: `Token ${get_token()}`,
                'Content-Type': 'application/json'
              },
              success: (response) => {
                if (response.status === 'success') {
                  Swal.fire({
                    title: 'Deleted!',
                    text: response.message,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'bottom-end',
                    toast: true
                  }).then(() => {
                    window.location.reload();
                  });
                }
              },
              error: (err) => {
                Swal.fire({
                  title: 'Error!',
                  text: err.responseJSON?.message || 'Something went wrong',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            });
          }
        });
      },
  },
  mounted() {
    this.fetch_businesses();
  }
};
